module.exports = __webpack_public_path__ + "assets/demo-screenshot-0f07ffbc6deb14c74c75f43bfadcf64c.jpg";